export { default as DefaultPage } from './DefaultPage';
export { default as FormRegistro } from './FormRegistro';
export { default as AgendamentoRpa } from './AgendamentoRpa';
export { default as FormRegistroAgendamentoRpa } from './FormRegistroAgendamentoRpa';



// WEBPACK FOOTER //
// ./src/features/login-sap/index.js